import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dokcategory',
  templateUrl: './dokcategory.component.html',
  styleUrls: ['./dokcategory.component.css']
})
export class DokcategoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
